// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import trendDown01Icon from "@/assets/icons/trend-down-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type TrendDown01IconProps = Omit<IconProps, "name">;

export function TrendDown01Icon(props: TrendDown01IconProps): React.ReactNode {
  return <Icon name={trendDown01Icon} {...props} />;
}
